<script setup lang="ts">
import { type ArticoloNorma } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: ArticoloNorma;
  compact?: boolean;
  showAreas?: boolean;
  showChildren?: boolean;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props" :content="content.norma">
    <template #info v-if="content.norma?.publisher">
      <span class="chip chip-solid-gray inline-block mt-2">{{ content.norma.publisher.title }}</span>
    </template>
    <template #footer>
      <div class="mt-3">
        <h4>
          <NuxtLink :href="link({ ...linkConfig, content: content })" class="link font-semibold">{{ content.title }}</NuxtLink>
        </h4>
        <p class="text-themeGray text-base leading-normal">{{ content.abstract }}</p>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
